import {
    MapOptions,
    BaseLayerType
} from "esdm-map/dist";
import { LayerGroupCollection } from "esdm-map/dist/layers/groups/LayerGroupCollection";
import { LincolnshireBaseLayers } from "./LincolnshireBaseLayerFactory";


export class DefaultMapOptions {

    public static GetDefaultOptions(
        mapElementId: string,
        mapStoreKey: string
    ): MapOptions {       

        let opt = new MapOptions();       
        opt.bingApiKey = $(`#${mapElementId}`).data("bing-api-key");
        opt.esdmOsmApiKey = $(`#${mapElementId}`).data("esdm-osm-api-key");
        opt.baseMaps = [LincolnshireBaseLayers.OSM, LincolnshireBaseLayers.OrdnanceSurvey_1888to1913, LincolnshireBaseLayers.OrdnanceSurvey_1937to1961];
        opt.defaultBaseMap = LincolnshireBaseLayers.OSM;
        opt.enableBoundsTracking = true;
        opt.zoomToNearestBounds = false;
        opt.maxZoomToBounds = 16;
        opt.mapElementId = mapElementId;
        opt.mapStoreKey = mapStoreKey;
        opt.mapZoom = 13;
        opt.minZoom = 9;
        opt.maxZoom = 17;
        opt.extent = [-155841, 6827029, 90278, 7234020];
        //opt.extent = [-131382, 6849348, 41887, 7098859];
        opt.mapCentre = [-60098, 7025403];
        opt.displayProjection = "EPSG:3857";
        opt.dataProjection = "EPSG:27700";
        opt.dragRotateAndZoom = false;        
        opt.zoomToNearestBounds = false;        
        return opt;
    }

}